import { render, staticRenderFns } from "./supplierInTransitList.vue?vue&type=template&id=292b5114&scoped=true"
import script from "./supplierInTransitList.vue?vue&type=script&lang=js"
export * from "./supplierInTransitList.vue?vue&type=script&lang=js"
import style0 from "./supplierInTransitList.vue?vue&type=style&index=0&id=292b5114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292b5114",
  null
  
)

export default component.exports